var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-chart-container h-100 w-100 height-override"},[_c('GChart',{staticClass:"account-balance-stacked-chart",attrs:{"data":_vm.getChartData,"options":_vm.getChartOptions,"type":"AreaChart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }